import React from "react";

function ArrowRightIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="12"
      fill="none"
      viewBox="0 0 7 12"
    >
      <path
        stroke="#121"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1 1.5L5.5 6 1 10.5"
      ></path>
    </svg>
  );
}

export default ArrowRightIcon2;
